import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { ItemsMenuEl } from "common/components/items-menu";
import { SelectEl } from "../select";
import { SvgIconEl } from "../svg-icon";
import { TagEl } from "../tag";
import { TagSize, TagTheme } from "../tag/types";
import { ButtonEl } from "../button";
import { TagInputTheme } from "./types";
function TagMenu() {
  if (!this.state.tagMenu) {
    return null;
  }
  return /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      open: this.state.tagMenu.isOpen,
      "prevent-close-selectors": [`.mp-tag-input-input-wrapper`]
    },
    on: {
      change: (ev) => this.handleTagMenuChange(ev)
    }
  }, this.state.tagMenu.isOpen && /* @__PURE__ */ jsx(ItemsMenuEl, {
    sel: ".mp-tag-input-tag-menu",
    attrs: {
      elref: `mpTagInputTagMenu`,
      "search-filter": this.getStagedTagSearch() || ``,
      "empty-message": `No results`,
      ...this.attr(`mp-items-menu-attrs`)
    },
    props: {
      sections: this.getTagMenuSections(),
      keydownProxyEl: this.state.tagMenu.isOpen ? this.state.searchInputEl : null
    },
    on: {
      clickItem: (ev) => this.handleClickTagItem(ev)
    }
  }));
}
export function template() {
  const isBreadcrumbs = this.attr(`theme`) === TagInputTheme.Breadcrumbs;
  const isLightTheme = this.attr(`theme`) === TagInputTheme.Light;
  const hasNoTags = !this.state.tagMap.size;
  const showSearchIcon = this.attr(`show-search-icon`);
  let tagTheme;
  if (isBreadcrumbs) {
    tagTheme = TagTheme.Breadcrumb;
  } else if (this.state.isInputFocused || isLightTheme) {
    tagTheme = TagTheme.Light;
  } else {
    tagTheme = TagTheme.Secondary;
  }
  const tagEls = Array.from(this.state.tagMap.values()).map((tag) => {
    return /* @__PURE__ */ jsx(TagEl, {
      attrs: {
        removable: this.helpers.canRemoveTag(tag),
        size: TagSize.Small,
        "tag-name": tag.label,
        theme: tagTheme,
        ...tag.attrs
      },
      key: `tag-${tag}`,
      on: { remove: this.helpers.canRemoveTag(tag) && this.helpers.removeTag(tag) }
    });
  });
  return /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-container",
    class: {
      "mp-tag-input-container--white-bg": this.state.isInputFocused,
      [`mp-tag-input-theme-${this.attr(`theme`)}`]: true
    }
  }, showSearchIcon && /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-search-icon"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `search` }
  })), /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-top-input-wrapper"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-input-wrapper",
    on: { click: this.helpers.focusInput }
  }, tagEls, /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-search-input-wrapper"
  }, /* @__PURE__ */ jsx("input", {
    sel: ".mp-tag-input-search-input",
    attrs: {
      placeholder: this.helpers.getPlaceholder(),
      disabled: this.attr(`disable-input`),
      elref: `mpTagInputSearchInput`
    },
    class: { "mp-tag-input-empty": hasNoTags },
    props: { type: `text`, value: this.state.inputText },
    on: {
      input: this.helpers.setInputText,
      keydown: this.helpers.handleKeyDown,
      focus: this.helpers.onFocusChange,
      blur: this.helpers.onFocusChange
    },
    style: { width: hasNoTags ? `100%` : this.state.inputWidth },
    hook: {
      insert: (vnode) => this.handleSearchInputInsert(vnode)
    }
  }), TagMenu.call(this)), /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-border",
    className: { "mp-tag-input-error": this.attr(`error`) }
  }))), this.attr(`show-clear`) && (this.state.tagMap.size > 0 || this.state.inputText) && /* @__PURE__ */ jsx("div", {
    sel: ".mp-tag-input-clear-icon",
    on: {
      click: this.helpers.onClearInput
    }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `circle-clear` }
  })), this.attr(`mp-select-attrs`) && /* @__PURE__ */ jsx(SelectEl, {
    sel: ".mp-tag-input-mp-select",
    attrs: this.helpers.processMpSelectAttrs(),
    on: {
      change: this.helpers.onSelectChange,
      menuChange: this.helpers.onSelectMenuChange
    }
  }), this.attr(`mp-button-attrs`) && /* @__PURE__ */ jsx(ButtonEl, {
    attrs: this.helpers.processMpButtonAttrs(),
    on: {
      click: this.helpers.onButtonPress
    }
  }));
}
